export default __webpack_public_path__ + "static/persona_relationship-e41939f96208e7e0e72bda89de64046f.png";